import React, {Component} from "react";
import PropTypes from "prop-types";
import Resource from "../../Resource";
import './index.css'

class LabelValueTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            column: null,
            maximize: false
        };

        this.ref = {
            table: React.createRef()
        };
    }

    static defaultProps = {
        rows: [],
        headerRow: null,
        footerRow: null,
        startCol: null,
        endCol: null,
        maximizable: false,
        onClick: _ => null
    };

    static propTypes = {
        rows: PropTypes.array,
        headerRow: PropTypes.array,
        footerRow: PropTypes.array,
        startCol: PropTypes.array,
        endCol: PropTypes.array,
        maximizable: PropTypes.bool,
        onClick: PropTypes.func
    };

    render() {
        const {state} = this;
        const {rows, headerRow, footerRow, startCol, endCol, maximizable} = this.props;

        return <React.Fragment>
            <table ref={this.ref.table} className={'LabelValueTable'}>
                <tbody>
                {headerRow && <tr className={'no-hover'}>
                    {startCol && <th>{maximizable ? <img className={'table-printer'} src={Resource.IMAGE.PACK[state.maximize ? 'MINIMIZE' : 'EXPAND']} onClick={this.fullscreen.bind(this)} alt={''}/> : null}</th>}
                    {headerRow.map((item, index) => <th key={index} className={state.column === index ? 'highlight' : ''} onMouseEnter={this.cellMouseEnterHandler.bind(this, index)} onMouseLeave={this.cellMouseLeaveHandler.bind(this)} onClick={this.cellClickHandler.bind(this, item?.data)}>{item?.value}</th>)}
                    {endCol && <th>{maximizable ? <img className={'table-printer'} src={Resource.IMAGE.PACK[state.maximize ? 'MINIMIZE' : 'EXPAND']} onClick={this.fullscreen.bind(this)} alt={''}/> : null}</th>}
                </tr>}
                {rows.map((row, index) => <tr key={index}>
                    {startCol && <th onClick={this.cellClickHandler.bind(this, startCol[index]?.data)}>{startCol[index]?.value}</th>}
                    {row.map((item, index) => <td key={index} className={`${item.data.isProductReduce ? 'low' : ''} ${state.column === index ? 'highlight' : ''}`} onMouseEnter={this.cellMouseEnterHandler.bind(this, index)} onMouseLeave={this.cellMouseLeaveHandler.bind(this)} onClick={this.cellClickHandler.bind(this, item?.data)}>{item?.data?.reservey ? `(${item?.data?.reservey})` : null} {item?.value || '-'}</td>)}
                    {endCol && <th onClick={this.cellClickHandler.bind(this, endCol[index]?.data)}>{endCol[index]?.value}</th>}
                </tr>)}
                {footerRow && <tr className={'no-hover'}>
                    {startCol && <th>{maximizable ? <img className={'table-printer'} src={Resource.IMAGE.PACK[state.maximize ? 'MINIMIZE' : 'EXPAND']} onClick={this.fullscreen.bind(this)} alt={''}/> : null}</th>}
                    {footerRow.map((item, index) => <th key={index} className={state.column === index ? 'highlight' : ''} onMouseEnter={this.cellMouseEnterHandler.bind(this, index)} onMouseLeave={this.cellMouseLeaveHandler.bind(this)} onClick={this.cellClickHandler.bind(this, item?.data)}>{item?.value}</th>)}
                    {endCol && <th>{maximizable ? <img className={'table-printer'} src={Resource.IMAGE.PACK[state.maximize ? 'MINIMIZE' : 'EXPAND']} onClick={this.fullscreen.bind(this)} alt={''}/> : null}</th>}
                </tr>}
                </tbody>
            </table>
        </React.Fragment>;
    }

    cellClickHandler(data) {
        this.props.onClick(data);
    }

    cellMouseEnterHandler(index) {
        this.setState({column: index});
    }

    cellMouseLeaveHandler() {
        this.setState({column: null});
    }

    fullscreen() {
        if (this.state.maximize) {
            try {
                document.exitFullscreen();
            } catch (e) {
            }
        } else {
            try {
                this.ref.table.current.requestFullscreen();
            } catch (e) {
            }
        }

        this.setState({
            maximize: !this.state.maximize
        });
    }

    print() {
        window.print();
    }
}

export default LabelValueTable;